import React from 'react';
import { Alert, Row, Col, Container } from 'reactstrap';
import { isPrimaryDomain } from '../domainSupport';
import useDashboardAlert from '../hooks/useDashboardAlert';

export default function DashboardAlert() {
  const {
    visible, alertHeading, alertText, alertType, showOnPrimaryDomainOnly, onDismiss,
  } = useDashboardAlert();

  if ((!showOnPrimaryDomainOnly || (showOnPrimaryDomainOnly && isPrimaryDomain())) && visible && alertText && alertType) {
    return (
      <Container className="dashboard">
        <Row>
          <Col md={12}>
            <Alert color={alertType} isOpen={visible} toggle={onDismiss}>
              {alertHeading && (
                <h4 className="text-muted">{alertHeading}</h4>
              )}
              <p className="text-muted">
                {alertText}
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }
  return null;
}
